import LangEnum from '../../../../lang/LangEnum';
import { MultiDynamicOptionsFilter } from '../../../Crud/filters/sharedBetweenFilters/types';
import { FilterFactoryGetLabelParams, IFilterHelperFactory } from '../filter-factory.types';
import { getMultiOptionFriendlyLabel } from '../filter-factory.utils';

class DynamicFilterHelper implements IFilterHelperFactory {
  constructor(private readonly filter: MultiDynamicOptionsFilter) {}

  getChipLabel({ translate }: FilterFactoryGetLabelParams) {
    const selectedOptions = this.filter.multiDynamicOptionsArgs?.selectedOptions;

    const selectedLabels = getMultiOptionFriendlyLabel(
      this.filter.multiDynamicOptionsArgs.allOptions,
      selectedOptions,
    );

    if (selectedLabels.length >= 3) {
      return `${this.filter.title}: ${selectedLabels.length} ${translate(LangEnum.GLOBAL_SELECTED_PLURAL)}`;
    }

    const isOrderConditionFilter =
      this.filter.multiDynamicOptionsArgs?.key.startsWith('orderCondition');

    const orderConditionHelperText = isOrderConditionFilter
      ? translate(LangEnum.ORDER_CONDITIONS_FILTER_CHIP_HELPER_TEXT)
      : '';

    return `${this.filter.title}${orderConditionHelperText}: ${selectedLabels.join(', ')}`;
  }

  getFriendlyLabel(): string {
    const selectedOptions = this.filter.multiDynamicOptionsArgs?.selectedOptions;

    const selectedText = getMultiOptionFriendlyLabel(
      this.filter.multiDynamicOptionsArgs.allOptions,
      selectedOptions,
    ).join(', ');

    return selectedText;
  }

  hasValue() {
    return this.filter.multiDynamicOptionsArgs?.selectedOptions?.length > 0;
  }

  isLoading() {
    const selectedOptions = this.filter.multiDynamicOptionsArgs?.selectedOptions;

    const selectedText = getMultiOptionFriendlyLabel(
      this.filter.multiDynamicOptionsArgs.allOptions,
      selectedOptions,
    ).join(', ');

    return selectedText.length <= 0;
  }
}

export default DynamicFilterHelper;
